import { KeycloakBearerInterceptor } from 'keycloak-angular';
import { CanActivateFn } from '@angular/router';
import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { HTTP_INTERCEPTORS, HttpParams } from '@angular/common/http';

import { ResetPasswordFn } from '../auth.types';
import { ISS_AUTH_GUARD, ISS_AUTH_SERVICE, ISS_RESET_PASSWORD } from '../auth.config';

import { KeycloakGuard } from './keycloak.guard';
import { KeycloakAuthService } from './keycloak-auth.service';

import { environment } from '@wo-environments';

const resetPassword: ResetPasswordFn = (redirectUri) => {
  const params = new HttpParams({
    fromObject: {
      response_type: 'code',
      client_id: environment.keycloak.clientId,
      redirect_uri: redirectUri || location.origin,
      kc_action: 'UPDATE_PASSWORD',
    },
  });

  return `${ environment.keycloak.url || '' }/realms/${ environment.keycloak.realm }/protocol/openid-connect/auth?${params.toString()}`;
};

export function keycloakAuthProviders(): EnvironmentProviders {
  return makeEnvironmentProviders([
    {
      provide: HTTP_INTERCEPTORS,
      useClass: KeycloakBearerInterceptor,
      multi: true,
    },
    {
      provide: ISS_AUTH_GUARD,
      useFactory: (guard: KeycloakGuard): CanActivateFn => (route, state) => guard.canActivate(route, state),
      deps: [ KeycloakGuard ],
    },
    {
      provide: ISS_AUTH_SERVICE,
      useClass: KeycloakAuthService,
    },
    {
      provide: ISS_RESET_PASSWORD,
      useValue: resetPassword,
    },
  ]);
}
